import React from "react";

export const getStorageOptions = ({ isGroupView, groupName }) => {
  if (!isGroupView) return { namespace: "all_bookings" };
  const normalizedGroup = (groupName || "my-lab").toLowerCase();
  return { namespace: `group_view_${normalizedGroup}` };
};

export const getInitialSelectedDateRange = ({
  user,
  get4WeekStartAndEndInISOString,
  readForcedTimelineRangeFromStorage,
  forceTimelineRangeKey,
  moment,
}) => {
  const defaultDateRange = [
    get4WeekStartAndEndInISOString("start", user.timezone),
    get4WeekStartAndEndInISOString("end", user.timezone),
  ];

  try {
    const parsed = readForcedTimelineRangeFromStorage();
    if (!parsed) return defaultDateRange;

    const { dateFrom, dateTo } = parsed;
    const tz = user?.timezone || "UTC";
    const fromStr = moment(dateFrom).tz(tz).format();
    const toStr = moment(dateTo).tz(tz).format();

    setTimeout(() => sessionStorage.removeItem(forceTimelineRangeKey), 1000);
    return [fromStr, toStr];
  } catch {
    return defaultDateRange;
  }
};

export const getSubscriptionOperation = ({ processingResult, commandId, commandType, quickEditTracker, BOOKING_OPERATIONS }) => {
  if (processingResult === "APPROVED_SUCCEEDED") return BOOKING_OPERATIONS.APPROVE;
  if (processingResult === "REJECTED_SUCCEEDED") return BOOKING_OPERATIONS.REJECT;
  if (quickEditTracker.isQuickEdit(commandId)) {
    return quickEditTracker.getOperation(commandId) || BOOKING_OPERATIONS.UPDATE;
  }

  // Check if this is an end or cancel operation based on commandType
  if (commandType === "END_REQUEST") {
    return BOOKING_OPERATIONS.END;
  }
  if (commandType === "CANCEL_REQUEST") {
    return BOOKING_OPERATIONS.CANCEL;
  }

  return BOOKING_OPERATIONS.CANCEL;
};

const invalidFilterFallbackView = (invalidFilterText) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px 16px",
        marginTop: "20px",
        textAlign: "center",
        height: "100%",
      }}
    >
      <span
        style={{
          backgroundColor: "#fefde1",
          border: "1px solid #ccc",
          padding: "8px 12px",
          borderRadius: "2px",
          fontSize: "14px",
        }}
      >
        {invalidFilterText}
      </span>
    </div>
  );
};

export const getViewContent = ({
  shouldRenderViews,
  isAnyListView,
  listViewDisplay,
  calendarViewDisplay,
  invalidFilterText,
}) => {
  if (!shouldRenderViews) return invalidFilterFallbackView(invalidFilterText);
  return isAnyListView ? listViewDisplay() : calendarViewDisplay();
};
